module.exports = __webpack_public_path__ + "img/avt-40-2.bd4b4a4d.png";